module.exports = __webpack_public_path__ + "img/cover.debdd5af.webp";